import { render } from "./EditorHeader.vue?vue&type=template&id=dc4e49a8&scoped=true"
import script from "./EditorHeader.vue?vue&type=script&lang=js"
export * from "./EditorHeader.vue?vue&type=script&lang=js"

import "./EditorHeader.vue?vue&type=style&index=0&id=dc4e49a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4e49a8"]])

export default __exports__